<template>
  <v-container fluid style="margin-top:15%">
    <v-row justify="center" align="center" style="height: 100%;">
      <v-slide-y-transition appear v-if="register">
        <v-card outlined class="ma-6 pa-6">
          <v-card-text class="text-center">
            <validate-observer ref="signUpObserver">
              <form>
                <validate-provider
                  v-slot="{ errors }"
                  name="username"
                  rules="required|email"
                >
                  <v-text-field
                    class="mb-6"
                    type="text"
                    label="メールアドレス"
                    prepend-icon="mdi-email-outline"
                    v-model="username"
                    :error-messages="errors"
                    v-on:keyup.enter="signUp"
                    required
                  />
                </validate-provider>
                <validate-provider
                  v-slot="{ errors }"
                  name="password"
                  rules="required|min:8"
                >
                  <v-text-field
                    class="mb-6"
                    label="パスワード"
                    color="#fffde0"
                    prepend-icon="mdi-lock-outline"
                    :append-icon="
                      showPass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                    "
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                    v-model="password"
                    :error-messages="errors"
                    v-on:keyup.enter="signUp"
                    required
                  />
                </validate-provider>
              </form>
            </validate-observer>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="grey"
              @click="register = !register"
              outlined
              style="font-size: 1rem;"
            >
              ログインへ
            </v-btn>
            <v-btn
              color="success"
              :loading="signUpLoading"
              @click="signUp"
              outlined
              style="font-size: 1rem;"
            >
              登録
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-slide-y-transition>
      <v-slide-y-transition appear v-else>
        <v-card outlined class="ma-6 pa-6">
          <v-card-text class="text-center">
            <validate-observer ref="signInObserver">
              <form>
                <validate-provider
                  v-slot="{ errors }"
                  name="username"
                  rules="required|email"
                >
                  <v-text-field
                    class="mb-6"
                    type="text"
                    color="#fffde0"
                    label="メールアドレス"
                    prepend-icon="mdi-email-outline"
                    v-model="username"
                    :error-messages="errors"
                    v-on:keyup.enter="signIn"
                    required
                  />
                </validate-provider>
                <validate-provider
                  v-slot="{ errors }"
                  name="password"
                  rules="required|min:8"
                >
                  <v-text-field
                    class="mb-6"
                    label="パスワード"
                    color="#fffde0"
                    prepend-icon="mdi-lock-outline"
                    :append-icon="
                      showPass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                    "
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                    v-model="password"
                    :error-messages="errors"
                    v-on:keyup.enter="signIn"
                    required
                  />
                </validate-provider>
              </form>
            </validate-observer>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="grey"
              @click="register = !register"
              outlined
              style="font-size: 1rem;"
            >
              登録へ
            </v-btn>
            <v-btn
              color="success"
              :loading="signInLoading"
              @click="signIn"
              outlined
              style="font-size: 1rem;"
            >
              ログイン
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-slide-y-transition>
    </v-row>
    <v-row justify="center" align="center">
      <v-alert
        v-model="successAlert"
        dense
        outlined
        dismissible
        transition="scale-transition"
        type="success"
      >
        <v-row align="center">
          <v-col class="grow" v-if="showResend">
            {{ successAlertMessage }}
          </v-col>
          <v-col class="shrink" v-if="showResend">
            <v-btn @click="resendVerification" color="grey" outlined>
              Resend
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-alert
        v-model="errorAlert"
        dense
        outlined
        dismissible
        transition="scale-transition"
        type="error"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ errorAlertMessage }}
          </v-col>
          <v-col class="shrink" v-if="showResend">
            <v-btn @click="resendVerification" color="grey" outlined>
              Resend
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-row>
  </v-container>
</template>

<script>
import { auth } from '@/config/firebase'
import { mapActions } from 'vuex'
import { ValidateObserver, ValidateProvider } from '@/plugins/validators'

export default {
  name: 'HomeLogin',
  components: {
    ValidateProvider,
    ValidateObserver
  },
  data: () => ({
    username: '',
    password: '',
    showPass: false,
    signInLoading: false,
    register: false,
    signUpLoading: false,
    errorAlert: false,
    errorAlertMessage: '',
    successAlert: false,
    successAlertMessage: 'Check your email to verify your account',
    showResend: false
  }),
  methods: {
    ...mapActions({
      signUpWithPassword: 'users/signUpWithPassword',
      signInWithPassword: 'users/signInWithPassword'
    }),
    clear() {
      this.username = ''
      this.password = ''
      if (this.$refs.signInObserver) {
        this.$refs.signInObserver.reset()
      }
      if (this.$refs.signUpObserver) {
        this.$refs.signUpObserver.reset()
      }
    },
    showSuccessAlert(message, withResend) {
      this.showResend = withResend ?? false
      this.errorAlert = false
      this.successAlertMessage = message
      this.successAlert = true
    },
    showErrorAlert(message, withResend) {
      this.showResend = withResend ?? false
      this.successAlert = false
      this.errorAlertMessage = message
      this.errorAlert = true
    },
    async signIn() {
      const valid = await this.$refs.signInObserver.validate()
      if (valid) {
        this.signInLoading = true

        try {
          const user = await this.signInWithPassword({
            email: this.username,
            password: this.password
          })

          if (user.emailVerified) {
            this.$router.push('/client/report')
            this.clear()
          } else {
            this.showErrorAlert(this.successAlertMessage, true)
          }
        } catch (error) {
          this.showErrorAlert(this.successAlertMessage, true)
        } finally {
          this.signInLoading = false
        }
      }
    },
    async signUp() {
      const valid = await this.$refs.signUpObserver.validate()
      if (valid) {
        this.signUpLoading = true

        const ok = await this.signUpWithPassword({
          email: this.username,
          password: this.password
        })

        if (ok) {
          this.clear()
          this.showSuccessAlert(this.successAlertMessage, true)
        } else {
          this.showErrorAlert('アカウント作成に失敗しました')
        }

        this.signUpLoading = false
      }
    },
    resendVerification() {
      auth.currentUser
        .sendEmailVerification()
        .then(() => {
          this.showSuccessAlert('Resent!')
        })
        .catch(error => {
          this.showErrorAlert(error.message)
        })
    }
  }
}
</script>
